import { Userpilot } from 'userpilot'

const SENSITIVE_CAPTURE_ATTRIBUTE = 'data-no-capture'
const SENSITIVE_CAPTURE_SELECTOR = `[${SENSITIVE_CAPTURE_ATTRIBUTE}]`

/**
 * Marks a subtree containing plaintext credentials so analytics and replay
 * vendors exclude it. Keep Userpilot's selector derived from the same marker;
 * these controls must not drift independently.
 */
export const SENSITIVE_CAPTURE_ATTRIBUTES = {
  'data-dd-privacy': 'hidden',
  [SENSITIVE_CAPTURE_ATTRIBUTE]: 'credentials',
} as const

/**
 * Initialize Userpilot with code-owned capture exclusions for sensitive DOM
 * subtrees. The SDK merges these settings into `window.userpilotSettings`
 * before loading its runtime script.
 */
export const initializeUserpilot = (token: string, nonce?: string): void => {
  Userpilot.initialize(token, {
    token,
    nonce,
    endpoint: 'up.paywithextend.com',
    domain: 'upsdk.paywithextend.com',
    proxy: 'all',
    auto_capture: {
      excluded_elements: [SENSITIVE_CAPTURE_SELECTOR],
    },
  })
}
